import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { reduxForm, Field, FieldArray, change } from 'redux-form';
import { Grid, Typography } from './../../../themes/default';
import { Section, Content, Main, Buttons, FormContent, FormActions } from './../../../components/includes/container';
import { ToolbarPrimary } from './../../../components/includes/toolbar';
import { BreadcrumbItem } from './../../../components/includes/breadcrumb';
import { Ttolbar } from './../../../components/includes/ui/table';
import { InputTextField, SelectField, OptionField } from './../../../components/includes/ui/input';
import { Btn } from './../../../components/includes/ui';
import { isEmail, isPasswordValid } from './../../../utilities/utils';
import { UserService, PermissionService } from './../../../services';

import Permission from './../permission';

import VALIDATION from './../../../config/validation';
//import ROLES from './../../../config/roles';

const validate = values => {

  const errors = {}

  if (!values.name) {
    errors.name = VALIDATION.required;
  }else if(values.name.length > 256){
    errors.name = 'The maximum is 256 characters';
  }

  if (!values.surname) {
    errors.surname = VALIDATION.required;
  }else if(values.surname.length > 256){
    errors.surname = 'The maximum is 256 characters';
  }

  if (!values.email) {
    errors.email = VALIDATION.required;
  } else if (isEmail(values.email)) {
    errors.email = VALIDATION.email;
  } else if (values.email.length > 256){
    errors.email = 'The maximum is 256 characters';
  }

  if (values.status === '-1') {
    errors.status = VALIDATION.required;
  }

  if (!values.password) {
    errors.password = VALIDATION.required;
  } else if( !isPasswordValid(values.password) ){
    errors.password = VALIDATION.password;
  }

  if (!values.confirm_password) {
    errors.confirm_password = VALIDATION.required;
  } else if (values.confirm_password !== values.password) {
    errors.confirm_password = VALIDATION.mismatched_password;
  }

  return errors

};

class UserCreate extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      permissions: []
    };
  }

  componentDidMount(){
    this._Permission();
  }

  /*
  ** @Service
  ** @Description: New
  */

  _Create = (values) => {

    UserService.create(values).then((response) => {

      /**
      * @Service find all by page
      */
      this.props.history.push('/users');

      /**
      * @Dispatch for alert success message
      */
      this.props.AlertShow({ open: true, variant: 'success', message: `Exitio, el registro fue creado.` });

    }).catch((error) => {

      // @Dispatch alert error
      this.props.AlertShow({ open: true, variant: 'error', message: error.data.message });

    });

  }

  /*
  ** @Service
  ** @Description: List of permissions
  */

  _Permission = () => {

    PermissionService.get().then((response) => {

      this.props.dispatch(change('UserCreate', 'permissions_available', response.permissions ));

    }).catch((error) => {

      // @Dispatch alert error
      this.props.AlertShow({ open: true, variant: 'error', message: 'error'});

    });

  }

  /*
  ** @Submit
  ** @Description: Toogle permissions
  */
  handleTooglePermision = (index, status) => {
    this.props.dispatch(change("UserCreate", `permissions_available[${index}].checked`, status))
  }

  /*
  ** @Submit
  ** @Description: Submit form user
  */
  handleSubmitForm = (values) => {
    this._Create(values);
  }

  render() {

    //const { permissions } = this.state;
    const { handleSubmit, invalid } = this.props;

    return (
      <Section>
        <ToolbarPrimary title="Usuarios"/>
        <BreadcrumbItem to='/users'>Usuarios</BreadcrumbItem>
        <BreadcrumbItem to='/create'>Crear</BreadcrumbItem>
        <Content>

          <Main>

            <form noValidate autoComplete="off" onSubmit={ handleSubmit(this.handleSubmitForm) }>

              <Ttolbar title="Creación de usuario"/>

              <FormContent enabledActions>

                <Grid container spacing={24}>
                  <Grid item lg={4} md={4} sm={12}>
                    <Field
                        name="name"
                        component={ InputTextField }
                        label="Nombre"
                        type="text"
                        required
                    />
                  </Grid>
                  <Grid item lg={4} md={4} sm={12}>
                    <Field
                        name="surname"
                        component={ InputTextField }
                        label="Apellido"
                        type="text"
                        required
                    />
                  </Grid>
                  <Grid item lg={4} md={4} sm={12}>
                    <Field
                        name="email"
                        component={ InputTextField }
                        label="Email"
                        type="email"
                        required
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={24}>

                  <Grid item lg={4} md={4} sm={12}>
                    <Field
                        name="status"
                        component={ SelectField }
                        label="Estado" required>
                          <OptionField key="-1" value="-1">Seleccionar...</OptionField>
                          <OptionField key="true" value="true">Activo</OptionField>
                          <OptionField key="false" value="false">Bloqueado</OptionField>
                    </Field>
                  </Grid>
                  <Grid item lg={4} md={4} sm={12}>
                    <Field
                        name="password"
                        component={ InputTextField }
                        label="Contraseña"
                        type="password"
                        required
                    />
                  </Grid>
                  <Grid item lg={4} md={4} sm={12}>
                    <Field
                        name="confirm_password"
                        component={ InputTextField }
                        label="Confirmar contraseña"
                        type="password"
                        required
                    />
                  </Grid>
                  {/*
                  <Grid item lg={4} md={4} sm={12}>
                    <Field
                        name="role"
                        component={ SelectField }
                        label="Profile" required>
                          <OptionField key="1" value="-1">Seleccionar...</OptionField>
                          { ROLES.length > 0 && (
                            ROLES.map(role => {
                              return(
                                <OptionField key={ role.key } value={ role.key }>{ role.name }</OptionField>
                              )
                            })
                          )}
                    </Field>
                  </Grid>
                  */}
                </Grid>

                <Grid container spacing={24}>
                  <Grid item lg={12} md={12} sm={12}>
                    <Typography variant="h6">Permisos</Typography>
                    <FieldArray name="permissions_available" component={ Permission } onChange={ this.handleTooglePermision }/>
                  </Grid>
                </Grid>

              </FormContent>

              <FormActions>
                <Grid container>
                  <Grid item lg={6} md={6} sm={12}>
                    <Buttons>
                      <Btn aria-label="Volver" icon="back" color="secondary" component={ NavLink } to="/users">
                        Volver
                      </Btn>
                    </Buttons>
                  </Grid>
                  <Grid item lg={6} md={6} sm={12}>
                    <Buttons align="right">
                      <Btn aria-label="Guardar" icon="add" color="success" type="submit" disabled={ invalid }>
                        Guardar
                      </Btn>
                    </Buttons>
                  </Grid>
                </Grid>
              </FormActions>

            </form>

          </Main>

        </Content>
      </Section>
    )
  }

}

UserCreate = reduxForm({
  form: 'UserCreate',
  validate,
  initialValues: {
    status: '-1',
    //role: '-1',
    permissions_available: []
  }
})(UserCreate);

const mapStateToProps = (state) => {
  return {
    Alert: state.Alert
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    AlertShow: (data) => {
      dispatch({
        type: 'ALERT_SHOW',
        data: data
      });
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UserCreate);
